import type { AiUsageKind, AiUsageScope } from '@/lib/api/master/ai-usage-api'

/**
 * Nome de cada funcionalidade que consome IA. A chave é a mesma de
 * `AI_USAGE_FEATURES` no backend (`ai-usage-recorder.constants.ts`): entrou
 * uma lá, entra aqui.
 */
export const AI_FEATURE_LABELS: Record<string, string> = {
    whatsapp_attendant: 'Atendente de WhatsApp',
    whatsapp_audio_transcription: 'Transcrição de áudio do WhatsApp',
    chat_summary: 'Resumo do atendimento',
    lead_sentiment: 'Sentimento do lead',
    sales_flow: 'Fluxos de vendas',
    payment_receipt: 'Leitura de comprovante',
    financial_assistant: 'Assistente financeiro',
    accounting: 'Classificação contábil',
    catalog_assistant: 'Assistente de catálogo',
    catalog_embedding: 'Busca semântica do catálogo',
    exam_order_import: 'Leitura de pedido médico',
    consultation_analysis: 'Análise da consulta',
    consultation_transcription: 'Transcrição da consulta',
    file_import: 'Importação assistida',
    payroll_import: 'Importação da folha',
    internal_chat: 'Chat interno',
    ai_user: 'Usuário de IA',
}

export const AI_KIND_LABELS: Record<AiUsageKind, string> = {
    CHAT: 'Conversa',
    EMBEDDING: 'Embeddings',
    TRANSCRIPTION: 'Transcrição',
}

export const AI_SCOPE_LABELS: Record<AiUsageScope, string> = {
    ORGANIZATION: 'Organizações',
    PLATFORM: 'Plataforma',
    UNOWNED: 'Sem dono',
}

export function featureLabel(feature: string): string {
    return AI_FEATURE_LABELS[feature] ?? feature
}
